module.exports = __webpack_public_path__ + "img/experiences_D Game ball delivery.dbeae116.jpg";